function ProjectCardLink({ href, label, icon, glass = false, tooltip }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
      className={`relative group/link flex items-center gap-1.5 px-3 py-1.5 rounded-full border font-sans text-xs transition-colors duration-200 ${
        glass
          ? "bg-white/80 dark:bg-black/70 backdrop-blur-sm border-white/30 dark:border-white/10 text-text-primary-light dark:text-text-primary-dark"
          : "border-border-light dark:border-border-dark text-text-muted-light dark:text-text-muted-dark hover:text-text-primary-light dark:hover:text-text-primary-dark hover:border-text-primary-light dark:hover:border-text-primary-dark"
      }`}
    >
      {icon}
      {label}
      {tooltip && (
        <span className="pointer-events-none absolute top-full left-1/2 -translate-x-1/2 mt-2 px-2 py-1 rounded-md text-2xs whitespace-nowrap bg-black/80 text-white opacity-0 group-hover/link:opacity-100 transition-opacity duration-150">
          {tooltip}
        </span>
      )}
    </a>
  );
}

export default ProjectCardLink;
